export enum CURSOR {
  NONE,
  CROSS_HAIR,
  PULSE,
}

type Props = {
  cursorType: CURSOR;
  left: number;
  top: number;
};

export const CursorDrawer = (props: Props) => {
  const { cursorType, left, top } = props;

  const getCursorClassName = (cursor: CURSOR) => {
    switch (cursor) {
      case CURSOR.CROSS_HAIR:
        return "crosshair";
      case CURSOR.PULSE:
        return "pulseMarker";
      default:
        return "none";
    }
  };

  return (
    <div
      className={`${getCursorClassName(cursorType)}`}
      style={{
        left: `${left}px`,
        top: `${top}px`,
        zIndex: 9999,
      }}
    />
  );
};
